import type { ReactNode } from 'react'
import { mergeClassNames } from '@/design-system/lib/mergeClassNames'

export interface FilterBarProps {
  children: ReactNode
  label?: string
  className?: string
  /** Contenu poussé à droite : compte de résultats, action de réinitialisation. */
  trailing?: ReactNode
}

/**
 * Barre de filtres d'une liste.
 *
 * Une seule disposition dans toute l'application : une ligne qui se replie
 * quand la place manque, jamais un empilement vertical de champs. Les Paiements
 * étaient le dernier écran à empiler les siens, faute d'une règle pour la
 * rangée qui les contenait.
 */
export function FilterBar({ children, className, label = 'Filtres', trailing }: FilterBarProps) {
  return (
    <div className={mergeClassNames('ds-filter-bar', className)} role="search" aria-label={label}>
      <div className="ds-filter-bar__fields">{children}</div>
      {trailing ? <div className="ds-filter-bar__trailing">{trailing}</div> : null}
    </div>
  )
}
